<template>
    <div style="padding-top: 15px;height: 100%;overflow: scroll;box-sizing: border-box;">
        <div class="agreement">
            <p style="text-align: center;font-size: 18px; font-weight: 600;">平台个人经营者承包经营合同</p>
            <p>甲 方：深圳致复科技有限公司</p>
            <p>（以下简称“甲方”）</p>
            <p>乙 方：{{userName}}</p>
            <p>（以下简称“乙方”）</p>
            <p>证件号码：{{idNo}}</p>
            <p>联系电话：{{phoneNo}}</p>
            <p>（在本协议下，甲方和乙方统称为“双方”，或各自被称为“各方”或“一方”。）</p>
            <p>一、合作内容</p>
            <p>1.甲方依托互联网承包经营平台，承接企业业务，由甲方将承包的业务众包给乙方完成，订单信息如下:</p>
            <p>承包商:深圳致复科技有限公司</p>
<!--            <p>承包商身份证号:</p>-->
            <p>承包商证件号:91440300MA5GXQE43L</p>
            <p>任务订单号:</p>
            <p>发布时间:2024年9月15日</p>
            <p>任务周期:按月更新</p>
            <p>任务名称:</p>
            <p>发任务类型:</p>
            <p>任务金额: 根据实际完成情况核算</p>
            <p>2.乙方是甲方通过平台智能筛选出的符合要求的服务提供商《承包商》，乙方与甲方建立承包
                经营关系，乙方通过甲方平台承接任务、交付成果、领取税后生产经营收入、委托办理涉税
                事宜等。</p>
            <p>二、任务认领</p>
            <p>1.乙方通过甲方平台、客户端、公众号等形式承接任务，生产经营收入、交付验收标准、业务
                类型等具体任务信息以系统记录信息为准。</p>
            <p>2.如甲方合作客户对任务需求做出调整，甲方便根据调整内容对乙方做出任务需求调整通知，
                乙方如接受任务需求调整，则甲乙双方就调整后的任务建立承包经营关系;乙方如拒绝调整，
                则双方基于调整前的业务建立的承包经营关系至此终止，双方不再互负违约责任及债权债务。</p>
            <p>三、任务成果交付</p>
            <p>1.乙方应当在规定的时间内完成承接的任务成果，并向甲方交付具体任务成果，如甲方按照成
                果验收标准验收交付的任务成果后认定不合格或乙方未提交任务成果，直至乙方提交合格的
                任务成果前，甲方可暂停发放生产经营收入。</p>
            <p>2.乙方交付的具体任务成果需和具体承接的任务保持一致，具体任务类型、明细以系统记录信
                息为准</p>
            <p>四、生产经营收入及支付方式</p>
            <p>当任务完成后，甲方平台会通过银行直接下发至个人银行卡中。</p>
            <p>五、甲方权利义务</p>
            <p>1.甲方有权就乙方提供的生产经营活动制定相应规则及标准，乙方应当遵守。</p>
            <p>2.甲方协助乙方获取生产经营所得时，应当按照有关税收政策规定及主管税务机关授予的代
                征权限（包括甲方合作的服务机构的代征权限）向乙方代征个人所得税等各项税款及行政收
                费（如有），或协助乙方按照有关税收政策规定及主管税务机关的要求缴纳个人所得税等各
                项税款及行政收费（如有）。</p>
            <p>3.甲方有权对乙方提供的信息进行验证，但该等验证行为并不意味着甲方对乙方信息的真实性
                、有效性、合法性、完整性负责，也并不因此减轻或免除乙方的任何义务或责任。</p>
            <p>4.甲方发现乙方违反相关法律法规或本协议规定的，甲方有权中止本协议。乙方应自行承担由
                此产生的税务相关的处罚责任，包括但不限于根据税务机关的要求补缴相应的税款、滞纳
                金等。甲方由此造成损失的，有权向乙方追偿。</p>
            <p>5.甲方承诺对乙方所披露的个人隐私信息进行保密。</p>
            <p>6.甲方可以留存为实现本次合作内容从乙方处获取的乙方个人信息。但是，未经乙方授权，
                甲方不得将乙方个人信息披露给除完成本协议项下内容的合作服务机构外的任何第三方。</p>
            <p>7.甲方承诺将按照相关法律法规的要求，对从乙方处获得的乙方个人信息履行安全保护义务，
                保障网络免受干扰、破坏或未经授权的访问，防止网络数据泄露或被窃取、篡改。</p>
            <p>8.如乙方与其客户之间如有非因本协议产生的争议或纠纷的，与甲方无关，甲方不承担任何责
                任。</p>
            <p>9.甲方向乙方提供本协议项下服务在任何情况下均不得被理解为与乙方之间建立或存在劳
                动/劳务合同关系、或其他类似的劳动人事法律关系。</p>
            <p>六、乙方权利义务</p>
            <p>1.乙方保证提供的个人信息等均是真实的、有效的、合法的、完整的，如信息变更应当及时通
                知甲方，与此有关的全部法律责任由乙方承担。同时，乙方知悉并确认，当且仅当其通过
                单等，均是真实的、有效的、合法的、完整的，如信息变更应当及时通知甲方，与此有关的
                全部法律责任由乙方承担。</p>
            <p>2.乙方保证提供各项业务往来信息，包括但不限于业务合作协议、相关补充协议及业务结算单等，均是真实的、有效的、合法的、完整的，如信息变更应当及时通知甲方，与此有关的
                全部法律责任由乙方承担。</p>
            <p>3.乙方有义务向甲方提供与生产经营所得相对应的收入凭据，并保证其均是真实的、有效的、
                合法的、完整的，如信息变更应当及时通知甲方，与此有关的全部法律责任由乙方承担。</p>
            <p>4.乙方有义务自行保护账户信息的安全，任何通过乙方账户进行的操作均将被视为乙方的真
                实意思表示，相应责任均由乙方自行承担。</p>
            <p>5.乙方承诺与其客户之间不具有下列关系：</p>
            <p>(1)与客户具有劳动/劳务合同关系、或其他类似的劳动人事法律关系；</p>
            <p>(2)与客户的关联企业具有劳动/劳务合同关系、或其他类似的劳动人事法律关系；</p>
            <p>(3)为客户及其关联企业的法定代表人、董事、监事、股东；</p>
            <p>(4)其他不适用于本协议适用范围之规定的人员关系。</p>
            <p>6.乙方发现甲方违反法律、行政法规的规定或者双方的约定收集、使用其个人信息的，有权
                要求其删除其个人信息；发现甲方收集、存储的其个人信息有错误的，有权要求其予以更正。
                甲方应当采取措施予以删除或者更正。</p>
            <p>7.乙方保证活动过程中遵守国家法律法规，因乙方个人原因造成其个人或任何第三方损害的
                责任，由乙方承担全部法律责任。</p>
            <p>8.乙方不得申请代开以下发票：</p>
            <p>（1）凡带有抵扣功能的普通发票；</p>
            <p>（2）非税务部门管理的经营收入。</p>
            <p>9.乙方承诺应当基于真实业务交易向甲方或甲方合作机构申请代开或委托甲方、甲方合
                作结构由税务机关代开相应发票并提供真实、准确、完整的开票信息，否则若乙方违反该承诺造
                成的相关法律责任及损失由乙方自行承担，若由此造成甲方损失或被相关行政机关处罚的，
                乙方应当承担赔偿责任。</p>
            <p>10.乙方不得从事违反法律及行政法规等行为，如洗钱、偷税漏税及其他甲方认为不得使用
                甲方服务的行为等。</p>
            <p>11.乙方确认，其具有完全民事权利能力及完全民事行为能力，所有业务合作均为其真实意
                愿，且遵守国家法律法规及行业监管要求并满足所有履行本协议所需的法定条件或约定条件。</p>
            <p>12.乙方确认，已知晓其生产经营所得的计算方式及结算周期。</p>
            <p>13.乙方可自行在甲方平台查询生产经营所得的计算方式、结算周期、支付途径等信息。</p>
            <p>14.乙方理解并同意，甲方及甲方的合作服务机构仅能根据乙方的委托及主管税务机关规定的
                或授予的委托代征范围、期限，及税种、税率等，协助乙方缴纳相关税费或依法代征相关税
                费，各地主管税务机关的具体规定可能不一致。同时，如遇国家或地方政府及主管税务机关
                政策变更的，甲方有权根据变更后的政策规定自动调整本协议项下的权利义务乃至终止本协
                议。</p>
            <p>15.为便利业务的开展，根据实际业务情况，甲方可能会安排一家或多家合作方（包括但不限
                于宿州伯通企业服务有限公司等）、关联方及/或分支机构作为实际业务提供方，为乙方提供
                本协议项下约定的服务，乙方对此知情并完全同意。同时，乙方同意授权并委托甲方为其申请数字证书，并签署所需的相关协议，但该协
                议应以不加重乙方的合同义务为限。</p>
            <p>16.乙方知悉并同意，经数字证书签署后的电子合同，与乙方以纸质形式进行的签章具有同
                等法律效力，对乙方具有不可撤销的法律约束力。乙方不得以未签署纸质合同为由、或未实
                际操作数字证书等理由，否认该等电子合同的法律效力。</p>
            <p>17.乙方知悉并同意，当符合以下任意一条情形时，该笔订单将不予计算服务费，若已做结
                算，平台有权在下次结算时予以相应扣除，或乙方在【5】个工作日内予以相应返还：</p>
            <p>（1）因任何原因导致该笔贷款未实际生效或被撤销/取消的；</p>
            <p>（2）平台发现有客户信息违法获取/使用、信息泄露等违规行为的；</p>
            <p>（3）平台发现有嫌欺诈、套现等违约行为，或存在其他违法违规操作的；</p>
            <p>（4）平台或合作方认定的不满足成功放款的其他情形；</p>
            <p>（5）平台或合作方认定的不满足服务质量要求的其他情形。</p>
            <p>七、保密条款</p>
            <p>1.本协议任何一方应对本协议所涉及的所有内容以及协议各方在执行本协议过程中相关的
                一切法律、商业、合作业务的所有资讯进行保密。未经对方允许，均不得向与协议无关的
                任意第三方披露</p>
            <p>2.保密期应为：协议的有效期内及协议终止之后的十年。</p>
            <p>八、违约责任</p>
            <p>任何一方违反本协议约定，即构成该方的违约；除本协议另有规定外，违约方应向守约方承
                担违约责任，补偿守约方承受或遭致的所有损失、责任、赔偿金或费用（包括但不限于合理
                的律师费、诉讼费、公证费等）。</p>
            <p>九、其他</p>
            <p>1.在本协议的任意一方或双方未能及时行使本协议项下的权利不应被视为放弃该权利，也不
                影响该方在将来行使该权利。</p>
            <p>2.本协议的订立、执行和解释及争议的解决均应适用中国法律。凡因本协议引起的或与本协
                议有关的任何争议，协议各方应友好协商解决。如不能协商解决，双方一致同意提交至甲方
                所在地人民法院进行诉讼。</p>
            <p>3.双方同意，在本协议签订后，如另有补充协议，该等补充协议及附件构成本协议不可分割
                的组成部分，具有同等法律效力。</p>
            <p>4.本协议项下各方声明、承诺和保证：本协议任何一方已披露签署和履行本协议所应当向另
                一方披露的全部信息，且披露内容真实、准确、无遗漏。协议各方同时声明和承诺：本协议
                的签署和履行不与本协议任何一方已经签署的协议或需承担的任何义务相冲突，且也不会对
                本协议任何一方以外的第三方形成任何法律和商业上的冲突。</p>
            <p>5.除本协议另有约定外，在履行本协议过程中的一切通知，甲方将通过在系统平台向乙方发
                送平台消息的方式送达乙方，甲方将通知消息发出之时即视为甲方完成通知义务。</p>
            <p>6.本协议经甲方盖章、乙方签字之日起生效，本协议有效期为壹年。协议到期后如双方均未
                以书面方式提出异议，则本协议有效期自动顺延壹年。本协议壹式贰份，甲乙双方各执壹份，
                每份具有同等法律效力。</p>
            <div style="display: flex;justify-content: space-between;margin-bottom: 100px;">
                <div>
<!--                    <div>甲方（盖章）：</div>-->
                    <div>甲方</div>
                    <div> 日期：2024-09-15</div>
                </div>
                <div>
<!--                    <div>乙方（签字）：</div>-->
                    <div>乙方</div>
                    <div> 日期：{{signDate}}</div>
                </div>
            </div>
            <div style="width: 100%;background-color: #f2f2f2;padding: 10px;box-sizing: border-box;">
                <van-button type="primary" @click="btnRouter">确认</van-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checked: false,
            userName: '',
            signDate: '',
            phoneNo: '',
            idNo: '',
            tbUserId: ''
        };
    },
    mounted() {
        this.userName = sessionStorage.getItem('tbUserName')
        this.idNo = sessionStorage.getItem('tbIdNo')
        this.phoneNo = sessionStorage.getItem('tbPhoneNo')
        this.signDate = sessionStorage.getItem('tbSignDate')
    },
    methods: {
        btnRouter() {
            this.$router.push({ path: '/taskection', query: { flag: 1 } });
        }
    }
}
</script>

<style lang="less" scoped>
.agreement {
    box-sizing: border-box;
    margin: 0 5px;
    height: 100%;
    // overflow: scroll;
    overflow-x: hidden;
    font-size: 14px;
    text-align: left;
    line-height: 2;
    background-color: #fff;
    border-radius: 7px;
    padding: 10px;
}

::-webkit-scrollbar {
    display: none;
}

::v-deep.van-button--primary {
    background-color: #07c160;
    border: 0.02667rem solid #e9a13d;
    background: #e9a13d;
    padding: 1px 40px !important;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
    margin-bottom: 20px;
}
</style>